// Import images
import logoImage from '../assets/logo.png';
import rocketImage from '../assets/rocket.png';

export const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-[#ECECFA] flex flex-col font-['Poppins',sans-serif]">
      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-8 md:py-12">
        {/* Logo - using PNG image */}
        <img
          src={logoImage}
          alt="Learnovate360"
          className="h-20 md:h-28 lg:h-32 w-auto"
        />

        {/* Rocket Illustration - using PNG image */}
        <div className="my-6 md:my-8">
          <img
            src={rocketImage}
            alt="Launching a project"
            className="w-full max-w-70 md:max-w-100 lg:max-w-125 h-auto"
          />
        </div>

        {/* Heading */}
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[56px] font-medium leading-[1.2] tracking-tight">
            <span className="text-gray-900">We are creating</span>
            <br />
            <span className="text-[#4F46E5]">
              something amazing
            </span>
          </h1>

          {/* Subtitle */}
          <p className="mt-4 md:mt-6 text-lg sm:text-xl md:text-2xl lg:text-4xl text-black/70 font-normal">
            We will launch our website soon!
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full max-w-7xl mx-auto px-8 py-6 flex items-center justify-center">
        {/* Copyright */}
        <p className="text-sm text-gray-500">
          Copyright &copy; 2026
        </p>
      </footer>
    </div>
  );
};
